import {
  SET_USER_NOTIFICATIONS,
  SET_USER_NOTIFICATIONS_LOADING
} from 'seller/store/saga/userNotifications/action';

const initialState = {
  notifications: [],
  loading: false
};

export const userNotificationsSelector = state => state.userNotifications;

const userNotificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_NOTIFICATIONS:
      return { ...state, notifications: action.notifications };
    case SET_USER_NOTIFICATIONS_LOADING:
      return { ...state, loading: action.loading };
    default:
      return state;
  }
};

export default userNotificationsReducer;
